import { render, staticRenderFns } from "./LayoutTemplate.vue?vue&type=template&id=312d6458&scoped=true&lang=html"
import script from "./LayoutTemplate.vue?vue&type=script&lang=js"
export * from "./LayoutTemplate.vue?vue&type=script&lang=js"
import style0 from "./LayoutTemplate.vue?vue&type=style&index=0&id=312d6458&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312d6458",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VIcon})
